module.exports = __webpack_public_path__ + "static/media/altPoster2.8c9227dd.png";